import { documentCardKind, type DocumentCardKind } from "./document-card.js";

export type DocumentPreviewMode = "pdf" | "text" | "image" | "unavailable";

function normalizedMime(mimeType: string | null | undefined): string {
  return mimeType?.split(";")[0]?.trim().toLowerCase() ?? "";
}

/** Native browser preview only. Office/Pages/ZIP stay unavailable. */
export function documentPreviewMode(
  fileName: string | null | undefined,
  mimeType: string | null | undefined,
): DocumentPreviewMode {
  const mime = normalizedMime(mimeType);
  if (mime.startsWith("image/")) {
    return "image";
  }
  if (mime === "application/pdf") {
    return "pdf";
  }
  if (mime === "text/plain") {
    return "text";
  }

  const kind: DocumentCardKind = documentCardKind(fileName, mimeType);
  switch (kind) {
    case "pdf":
      return "pdf";
    case "text":
      return "text";
    case "word":
    case "excel":
    case "powerpoint":
    case "generic":
      return "unavailable";
    default: {
      const _exhaustive: never = kind;
      return _exhaustive;
    }
  }
}

export function documentPreviewIsNative(mode: DocumentPreviewMode): boolean {
  return mode === "pdf" || mode === "text" || mode === "image";
}
